import {
  getInvStockAvailableQty,
} from '#/modules/imsMgmt/receipts/stockTransfer/helper/formSerialize';

function formatWarehouseLocationLabel(warehouse) {
  if (!warehouse) {
    return '';
  }

  const warehouseLabel = warehouse.code
    ? `${warehouse.code} ${warehouse.name ?? ''}`.trim()
    : (warehouse.name ?? '');
  const location = warehouse.location;
  if (!location) {
    return warehouseLabel;
  }

  const locationLabel = location.code
    ? `${location.code} ${location.name ?? ''}`.trim()
    : (location.name ?? '');

  return [warehouseLabel, locationLabel].filter(Boolean).join(' / ');
}

function resolveLineBaseQty(line) {
  const raw = line?.baseQty ?? line?.adjustmentQty;
  if (raw === '' || raw == null) {
    return '';
  }
  return raw;
}

export function createEmptyAdjustmentLine() {
  return {
    invStockId: '',
    stockNo: '',
    mtrNo: '',
    mtrName: '',
    warehouseLabel: '',
    availableQty: 0,
    baseQty: '',
    remark: '',
  };
}

/**
 * 庫存列表列 → 調整明細列（調整量空白，勿預填 0 或目前量）。
 */
export function mapInvStockRowToAdjustmentLine(row) {
  if (!row?.id) {
    return null;
  }

  return {
    invStockId: row.id,
    stockNo: row.stockNo ?? '',
    mtrNo: row.mtr?.mtrNo ?? '',
    mtrName: row.mtr?.name ?? '',
    warehouseLabel: formatWarehouseLocationLabel(row.warehouse),
    availableQty: getInvStockAvailableQty(row),
    baseQty: '',
    remark: '',
  };
}

/**
 * Create／Update body。MANUAL 不送 sourceType／sourceId（對齊 BE create 白名單）。
 * lines 僅 invStockId＋signed baseQty＋remark。
 */
export function buildStockAdjustmentWritePayload(values, { updatedAt = null } = {}) {
  const payload = {
    adjustmentDate: values.adjustmentDate || null,
    issueReason: values.issueReason || null,
    remark: values.remark || null,
    lines: (values.lines ?? []).map((line) => ({
      invStockId: line.invStockId,
      baseQty: line.baseQty === '' || line.baseQty == null
        ? null
        : Number(line.baseQty),
      remark: line.remark || null,
    })),
  };

  const sourceType = values.sourceType || 'MANUAL';
  if (sourceType !== 'MANUAL') {
    payload.sourceType = sourceType;
    payload.sourceId = values.sourceId || null;
  }

  if (updatedAt) {
    payload.updatedAt = updatedAt;
  }

  return payload;
}

export function mapStockAdjustmentDetailToFormValues(detail) {
  return {
    adjustmentDate: detail?.adjustmentDate ?? '',
    sourceType: detail?.sourceType ?? 'MANUAL',
    sourceId: detail?.sourceId ?? '',
    issueReason: detail?.issueReason ?? '',
    remark: detail?.remark ?? '',
    lines: (detail?.lines ?? []).map((line) => {
      const invStock = line.invStock;
      const availableQty = Number(
        invStock?.availableQty ?? invStock?.baseQty ?? line.qtyBefore ?? 0,
      );

      return {
        invStockId: invStock?.id ?? line.invStockId ?? '',
        stockNo: invStock?.stockNo ?? '',
        mtrNo: line.mtr?.mtrNo ?? invStock?.mtr?.mtrNo ?? '',
        mtrName: line.mtr?.name ?? invStock?.mtr?.name ?? '',
        warehouseLabel: formatWarehouseLocationLabel(
          line.warehouse ?? invStock?.warehouse,
        ),
        availableQty: Number.isFinite(availableQty) ? availableQty : 0,
        baseQty: resolveLineBaseQty(line),
        remark: line.remark ?? '',
      };
    }),
  };
}
